"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AnsweredQuestion_1 = require("../Model/Question/AnsweredQuestion");
const Collection_1 = require("../Model/Collection");
const configs_1 = require("../configs/configs");
class AnsweredQuestionToDataTransformer {
    constructor(answerOptionTransformer, numberFormatter) {
        this.answerOptionTransformer = answerOptionTransformer;
        this.numberFormatter = numberFormatter;
    }
    /**
     * @inheritDoc
     */
    to(question) {
        return {
            question: question.getId(),
            chosenAnswers: question.getChosenAnswerOptions(),
            answerValue: question.getValue()
        };
    }
    /**
     * @inheritDoc
     */
    from(data) {
        const options = new Collection_1.default(data.chosenAnswers.items.map((opt) => this.answerOptionTransformer.from(opt)));
        return new AnsweredQuestion_1.default()
            .setId(data.questionReference)
            .setValue(this.numberFormatter.format(data, [configs_1.configs.questionReferences.outstanding_finance_value]))
            .setChosenAnswerOptions(options);
    }
}
exports.default = AnsweredQuestionToDataTransformer;
